import { SITE_URL } from '../../constants'
import { buildCaseStudySchema } from '../../builders/caseStudy'
import { PageMeta } from '../../types'

const description = "各プロダクトでUIが乱立していたマクロミルに対し、デザイン原則策定からFigmaコンポーネント・Reactライブラリ連携まで一気通貫で支援。プロトタイプ作成が1か月から2週間に短縮された、複数プロダクトのUI統一・デザインガバナンス強化の事例です。"

const primaryImage = "https://www.i3design.jp/images/img/cases/macromill-designsystem/ogp_macromill-designsystem.png"

export const macromillDesignsystemPageMeta: PageMeta = {
  title: "マクロミル 複数プロダクトのUI統一とコスト削減｜デザインシステム導入事例 | i3DESIGN",
  description,
  keyword: "マクロミル,デザインシステム,UIUX,プロダクト,figma",
  image: primaryImage,
  url: `${SITE_URL}/cases/macromill-designsystem/`,
}

export const macromillDesignsystemSchema = buildCaseStudySchema({
  slug: "macromill-designsystem",
  pageTitle: macromillDesignsystemPageMeta.title,
  description: macromillDesignsystemPageMeta.description,
  headline: "運用工数&コストの削減をデザインシステム導入で実現",
  alternativeHeadline: "株式会社マクロミル",
  primaryImage,
  images: ["https://www.i3design.jp/images/img/cases/macromill-designsystem/ogp_macromill-designsystem.png","https://www.i3design.jp/images/img/cases/macromill-designsystem/mv.webp"],
  clientName: "株式会社マクロミル",
  breadcrumbLabel: "運用工数&コストの削減をデザインシステム導入で実現",
})
